import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelIconOutlined from "@mui/icons-material/CancelOutlined";

export interface TableCellBoolProps {
  value: boolean;
}

const TableCellBool: React.FC<TableCellBoolProps> = ({ value, ...otherProps }) => {
  return (
    <>
      {value ? (
        <CheckCircleOutlinedIcon
          className="MuiCheckCircleIcon-root"
          color="success"
          fontSize="small"
          sx={{ ml: 0.5 }}
          {...otherProps}
        />
      ) : (
        <CancelIconOutlined
          className="MuiCheckCircleIcon-root"
          color="disabled"
          fontSize="small"
          sx={{ ml: 0.5 }}
          {...otherProps}
        />
      )}
    </>
  );
};

export default TableCellBool;
